module.exports = __webpack_public_path__ + "static/media/powerpoint-icon.b4bf8683.svg";